import { DffCookieConsentCookie } from "@e-forsyning/web-components/shared/dff-cookie-consent";
import { DffCookieConsentCookieWithDescription } from "@e-forsyning/web-components/shared/cookie-mapper.utils";

import registry from "./servicepro-cookies.json";
import { ServiceProCookieEntry, ServiceProCookieRegistry } from "./servicepro-cookies.model";

const cookieRegistry = registry as ServiceProCookieRegistry;

export function getServiceProCookieRegistry(): ServiceProCookieRegistry {
    return cookieRegistry;
}

export function getServiceProConsentVersion(): string {
    return cookieRegistry.consentVersion;
}

export function mapServiceProCookiesForDialog(): {
    mandatory: DffCookieConsentCookieWithDescription[];
    optional: DffCookieConsentCookieWithDescription[];
} {
    const cookies = cookieRegistry.cookies.filter((entry) => entry.listInPolicy !== false).map(toDialogCookie);
    return {
        mandatory: cookies.filter((c) => c.mandatory),
        optional: cookies.filter((c) => !c.mandatory)
    };
}

export function getServiceProConsentGatedEntries(): ServiceProCookieEntry[] {
    return cookieRegistry.cookies.filter((entry) => entry.consentGated);
}

function toDialogCookie(entry: ServiceProCookieEntry): DffCookieConsentCookieWithDescription {
    const cookie: DffCookieConsentCookie = {
        processor: entry.processor,
        name: entry.name,
        domain: entry.domain === "{host}" ? "" : entry.domain,
        expiry: entry.expiry,
        type: entry.type,
        mandatory: entry.mandatory
    };
    return {
        ...cookie,
        description: entry.purpose
    };
}
